import { doPut } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import type { CallReviewNote } from './types';

export const updateNote = ({
  accountId,
  projectId,
  conversationId,
  note,
}: {
  accountId: string;
  projectId: string;
  conversationId: string;
  note: string;
}) => {
  return doPut<CallReviewNote>(
    `accounts/${accountId}/projects/${projectId}/conversations/${conversationId}/review-notes`,
    LOGGER_TYPE.CONVERSATIONS,
    { note: note },
  );
};
